export const AUTHENTICATION = "AUTH/authentication";
export const LOGIN = "AUTH/login";
export const LOGIN_MPIN = "AUTH/login_with_mpin";
export const LOGOUT = "AUTH/logout";
